import React from 'react';
import { Section } from './Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section className="bg-cream" data-id="element-168">
      <div className="max-w-3xl mx-auto bg-white p-8 md:p-12 rounded-3xl border border-brown/10 shadow-sm flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-169">
        <div className="shrink-0 bg-sage/10 p-4 rounded-full" data-id="element-170">
          <ShieldCheck className="w-16 h-16 text-sage" data-id="element-171" />
        </div>
        <div data-id="element-172">
          <h2 className="font-serif text-2xl md:text-3xl text-brown mb-4" data-id="element-173">
            Try It Risk-Free
          </h2>
          <p className="text-brown-light text-lg" data-id="element-174">
            If you don't gain meaningful personal windows — your 30 minutes of
            protected time — within 14 days, request a full refund. No questions
            asked.
          </p>
        </div>
      </div>
    </Section>;
}